<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="aboutUs">
				<!-- <div class="tabbar">
					<div class="item" @click="barClick(index)" :class="{ active: count == index }"
						v-for="(item, index) in list">
						<div class="txt">{{ item }}</div>
						<div class="line"></div>
					</div>
				</div> -->
				<div class="body body-contact-mobile">
					<!-- <div id="map" style="width: 8.933333rem;height: 6.666667rem;margin-top: 0.266667rem;"></div> -->
					<div class="info info-mobile">
						<div class="m-companyName">{{ info.companyName }}</div>

						<div class="m-section" v-if="addressLines.length">
							<div class="m-label">地址</div>
							<div class="m-value" v-for="(line, i) in addressLines" :key="'m-addr-' + i">{{ line }}</div>
						</div>

						<div class="m-section" v-if="info.dawk">
							<div class="m-label">邮编</div>
							<div class="m-value">{{ info.dawk }}</div>
						</div>

						<div class="m-section" v-if="info.fax">
							<div class="m-label">传真</div>
							<div class="m-value">{{ info.fax }}</div>
						</div>

						<div class="m-hotline" v-if="phoneList.length">
							<!-- <div class="m-hotline-title">联系热线</div> -->
							<div class="m-contact-card" v-for="(item, index) in phoneList" :key="'m-ph-' + index">
								<div class="m-contact-name">{{ item.key }}</div>
								<div class="m-phone-lines">
									<div class="m-phone-line" v-for="(line, pi) in splitPhoneLines(item.value)" :key="pi">{{ line }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="aboutUs">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt=""> <span @click="toTopImg()" style="cursor: pointer;">首页</span>
						<span style="color: black;">></span><span>联系我们</span>
						<!-- <span
							style="color: black;">></span><span>联系我们</span> -->
					</div>
				</div>
				<div class="main">
					<!-- <div class="left">
						<div class="top">联系我们</div>
						<div v-for="(item, index) in list" class="bar" :class="{ bar1: count == index }"
							@click="barClick(index)">{{
								item
							}}</div>

					</div> -->
					<div class="right contact-right">
						<!-- PC 布局参考 Figma node 2030-39：https://www.figma.com/design/UN7VDxbDeB2gR1DcR53T4o/%E5%9B%BD%E6%9C%BA%E9%9B%86%E5%9B%A2?node-id=2030-39 -->
						<div class="contact-figma-layout">
							<div class="companyInfoCard">
								<p class="companyNameFigma">{{ info.companyName }}</p>
								<div class="infoRows">
									<div class="infoRow" v-if="addressLines.length">
										<img src="../assets/figma-contact/mnzqmuhs-egzvrj4.svg" class="iconAddr" alt="" />
										<div class="infoCol">
											<p class="labelUpper">地址</p>
											<p class="valueMain" v-for="(line, i) in addressLines" :key="'addr-' + i">{{ line }}</p>
										</div>
									</div>
									<div class="infoRow" v-if="info.dawk">
										<img src="../assets/figma-contact/mnzqmuhs-2kwvfeg.svg" class="iconPost" alt="" />
										<div class="infoCol">
											<p class="labelUpper">邮编</p>
											<p class="valuePlain">{{ info.dawk }}</p>
										</div>
									</div>
									<div class="infoRow" v-if="info.fax">
										<img src="../assets/figma-contact/mnzqmuhs-b0m60gb.svg" class="iconFax" alt="" />
										<div class="infoCol">
											<p class="labelUpper">传真</p>
											<p class="valuePlain">{{ info.fax }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="contactPersonsGrid" v-if="contactRows.length">
								<!-- <p class="hotlineTitle">联系热线</p> -->
								<div class="contactRow" v-for="(row, ri) in contactRows" :key="'row-' + ri">
									<div class="contactCard" v-for="(item, ii) in row" :key="ri + '-' + ii">
										<div class="contactHead">
											<img src="../assets/figma-contact/mnzqmuht-j7eovsp.svg" class="avatarIcon" alt="" />
											<p class="contactName">{{ item.key }}</p>
										</div>
										<div class="contactPhone">
											<img src="../assets/figma-contact/mnzqmuht-z91t7ug.svg" class="phoneIcon" alt="" />
											<div class="phoneNumberList">
												<p class="phoneNumber" v-for="(line, pi) in splitPhoneLines(item.value)" :key="pi">{{ line }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import {
	contactUs
} from '../api/api'
export default {
	name: 'aboutUsTemplate',
	data() {
		return {
			list: ['联系我们'], //二级菜单数组
			parentId: this.$route.query.parentId || '', //二级菜单数组id
			count: 0,
			info: {},
		}
	},
	created() {
		this.getList() //二级菜单
	},
	computed: {
		addressLines() {
			if (!this.info.address) return []
			return this.info.address.split('；').map(s => s.trim()).filter(Boolean)
		},
		contactRows() {
			const phones = Array.isArray(this.info.phone) ? this.info.phone : []
			const rows = []
			for (let i = 0; i < phones.length; i += 2) {
				rows.push(phones.slice(i, i + 2))
			}
			return rows
		},
		phoneList() {
			return Array.isArray(this.info.phone) ? this.info.phone : []
		},
	},
	methods: {
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			})
		},
		//二级菜单
		getList() {
			contactUs().then(res => {
				this.info = res.data
				this.info.phone = JSON.parse(this.info.phone);
				setTimeout(() => {
					this.initMap();
				}, 1000);
			})
		},
		barClick(index) {
			this.count = index
		},
		/** 多个号码用分号、逗号、顿号、斜杠等分隔时，拆成多行展示；单个号码内的空格保留 */
		splitPhoneLines(value) {
			if (value == null || value === '') return []
			const raw = String(value).trim()
			if (!raw) return []
			const parts = raw
				.split(/[；;，,、\/|]+|\n+/)
				.map(s => s.trim())
				.filter(Boolean)
			return parts.length ? parts : [raw]
		},
		//地图
		initMap() {
			// let map = ''
			let map = new AMap.Map(('map'), {
				//设置地图容器id
				viewMode: "2D", //是否为3D地图模式
				zoom: 16, //初始化地图缩放级别
				center: [this.info.lng, this.info.lat], //初始化地图中心点位置
			}).add(
				new AMap.Marker({
					map: map,
					position: [this.info.lng, this.info.lat], // 和上面的center 一样的
					offset: new AMap.Pixel(-15, -30),
					icon: new AMap.Icon({
						size: new AMap.Size(64, 64), // 图标尺寸
						// image: require("../assets/contact_addr.png"), // Icon的图像
						imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量
						imageSize: new AMap.Size(30, 30), // 根据所设置的大小拉伸或压缩图片，一般不用
					}),
				})
			);

		},
	}
}
</script>




<style scoped lang="scss">
.device-mobile {
	.aboutUs {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 0.533333rem;

		.tabbar {
			width: 9.466667rem;
			height: 1.653333rem;
			display: flex;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.4rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007CC3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.body-contact-mobile {
			margin-top: 0.266667rem;
		}

		.body {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 9.466667rem;
			background: #FFFFFF;
			box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.info-mobile {
				width: 8.733333rem;
				padding: 0.533333rem 0 0.64rem;
				box-sizing: border-box;
			}

			.m-companyName {
				font-size: 0.426667rem;
				font-weight: bold;
				line-height: 1.45;
				color: #003461;
			}

			.m-section {
				margin-top: 0.4rem;

				.m-label {
					font-size: 0.293333rem;
					line-height: 1.3;
					letter-spacing: 0.02em;
					color: #424750;
					font-weight: 600;
					margin-bottom: 0.106667rem;
				}

				.m-value {
					font-size: 0.346667rem;
					line-height: 1.5;
					color: #191c1e;
					word-break: break-word;

					& + .m-value {
						margin-top: 0.133333rem;
					}
				}
			}

			.m-hotline {
				margin-top: 0.48rem;
				padding-top: 0.426667rem;
				border-top: 1px solid #ededed;
			}

			.m-hotline-title {
				font-size: 0.4rem;
				font-weight: bold;
				color: #000;
				margin-bottom: 0.32rem;
			}

			.m-contact-card {
				padding: 0.32rem 0.373333rem;
				margin-bottom: 0.266667rem;
				background: #f5f5f5;
				border-radius: 0.213333rem;
				box-sizing: border-box;

				&:last-child {
					margin-bottom: 0;
				}
			}

			.m-contact-name {
				font-size: 0.373333rem;
				font-weight: 600;
				color: #191c1e;
				line-height: 1.4;
			}

			.m-phone-lines {
				margin-top: 0.213333rem;
				display: flex;
				flex-direction: column;
				gap: 0.106667rem;
			}

			.m-phone-line {
				font-size: 0.346667rem;
				font-weight: 600;
				color: #003461;
				line-height: 1.45;
				word-break: break-all;
			}
		}
	}
}

.device-pc {
	.contact-right {
		background: #f5f5f5;
		// min-height: 480px;
		height: auto;
	}

	.contact-figma-layout {
		display: flex;
		flex-wrap: wrap;
		// align-items: flex-start;
		justify-content: center;
		column-gap: 48px;
		row-gap: 32px;
		width: 100%;
		box-sizing: border-box;
		padding: 40px 40px 48px;
	}

	.companyInfoCard {
		display: flex;
		flex-direction: column;
		flex: 1 1 400px;
		max-width: 520px;
		min-width: 280px;
		padding: 40px;
		border-radius: 12px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
		background: #fff;
		row-gap: 32px;
	}

	.companyNameFigma {
		margin: 0;
		line-height: 30px;
		color: #003461;
		font-size: 24px;
		font-weight: 500;
	}

	.infoRows {
		display: flex;
		flex-direction: column;
		align-self: stretch;
		row-gap: 24px;
		padding-bottom: 16px;
	}

	.infoRow {
		display: flex;
		align-items: flex-start;
		column-gap: 16px;
		align-self: stretch;
	}

	.iconAddr {
		flex-shrink: 0;
		width: 40px;
		height: 44px;
		border-radius: 8px;
	}

	.iconPost,
	.iconFax {
		flex-shrink: 0;
		width: 44px;
		height: 40px;
		border-radius: 8px;
	}

	.iconFax {
		height: 41px;
	}

	.infoCol {
		display: flex;
		flex-direction: column;
		row-gap: 4px;
		min-width: 0;
	}

	.labelUpper {
		margin: 0;
		line-height: 16px;
		letter-spacing: 0.6px;
		color: #424750;
		font-size: 12px;
		font-weight: 600;
		text-transform: uppercase;
	}

	.valueMain,
	.valuePlain {
		margin: 0;
		line-height: 24px;
		color: #191c1e;
		font-size: 16px;
		font-weight: 500;
	}

	.contactPersonsGrid {
		display: flex;
		flex-direction: column;
		flex: 1 1 400px;
		max-width: 720px;
		min-width: 280px;
		row-gap: 30px;
	}

	.hotlineTitle {
		margin: 0;
		line-height: 34px;
		color: #000;
		font-size: 28px;
	}

	.contactRow {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
		gap: 16px 24px;
		width: 100%;
	}

	.contactCard {
		display: flex;
		flex-direction: column;
		flex: 1 1 200px;
		max-width: calc(50% - 12px);
		min-width: 200px;
		padding: 22px 32px;
		border-radius: 12px;
		background: #fff;
		row-gap: 4px;
		box-sizing: border-box;
	}

	.contactHead {
		display: flex;
		align-items: center;
		column-gap: 10px;
		align-self: stretch;
	}

	.avatarIcon {
		flex-shrink: 0;
		width: 40px;
		height: 40px;
		border-radius: 4px;
	}

	.contactName {
		flex: 1;
		margin: 0;
		line-height: 28px;
		color: #191c1e;
		font-size: 16px;
		font-weight: 500;
	}

	.contactPhone {
		display: flex;
		align-items: flex-start;
		column-gap: 12px;
		padding-top: 20px;
		align-self: stretch;
	}

	.phoneIcon {
		flex-shrink: 0;
		width: 11px;
		height: 11px;
		margin-top: 8px;
	}

	.phoneNumberList {
		display: flex;
		flex-direction: column;
		gap: 4px;
		min-width: 0;
	}

	.phoneNumber {
		margin: 0;
		line-height: 28px;
		color: #003461;
		font-size: 18px;
		font-weight: 600;
	}

	.aboutUs {
		width: 100vw;
		// display: flex;
		// justify-content: center;
		background: #F5F5F5;
		padding-bottom: 50px;
	}

	.main {
		display: flex;
		width: 1300px;
		margin: 0 auto;
		padding-top: 25px;

	}

	.left {
		// background: #FFFFFF;

		.top {
			width: 270px;
			height: 64px;
			background: url('../assets/bannerImg.png') no-repeat;
			background-size: 100%;
			font-size: 26px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.bar {
			width: 270px;
			height: 48px;
			background: #FFFFFF;
			border-bottom: 1px solid #EDEDED;
			font-size: 18px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			cursor: pointer;
		}

		.bar1 {
			font-size: 18px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #0175C2;
			border-bottom: 1px solid #0175C2;
		}
	}

	.right {
		width: 1300px;
		display: flex;
		box-sizing: border-box;
	}

	.navigation {

		width: 100vw;
		background: #fff;
		display: flex;
		align-items: center;


		.navigationItem {
			width: 1300px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			// margin-top: 15px;
			height: 36px;
			line-height: 36px;
			margin-bottom: 20px;
			padding-top: 15px;
			box-sizing: border-box;
			color: #1979b7;
			font-size: 20px;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;

		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue